












































































import { PropType } from 'vue';
import { mapActions } from 'vuex';

import { IContractItem } from '@/models';
import { ISystemError } from '@/models/error/error.types';

import { setErrorFromAxiosError } from '@/utils/helpers';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';

import DetailOptionsButton from '../common/DetailOptionsButton.vue';
import ConfirmationDialog from '../common/ConfirmationDialog.vue';

export default mixins(auth).extend({
  name: 'ContractItemDetailOptionsButton',

  components: {
    ConfirmationDialog,
    DetailOptionsButton
  },

  props: {
    contractItem: {
      type: Object as PropType<IContractItem>,
      required: true
    },
    contractId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      deleteContractItemDialog: false,
      isDeleteInProgress: false,
      error: null as null | ISystemError
    };
  },

  methods: {
    ...mapActions({
      deleteContractItem: 'contract/deleteContractItem'
    }),

    cancelContractItemDeleteDialog() {
      this.deleteContractItemDialog = false;
    },

    removeContractItem() {
      this.clearErrors();
      this.isDeleteInProgress = true;
      this.deleteContractItem({
        contractId: this.contractId,
        itemId: this.contractItem.id
      })
        .then(() => {
          this.deleteContractItemDialog = false;
        })
        .catch(error => {
          this.error = setErrorFromAxiosError(error);
        })
        .finally(() => {
          this.isDeleteInProgress = false;
        });
    },

    clearErrors() {
      this.error = null;
    }
  }
});
